module.exports = __webpack_public_path__ + "static/media/_bitcoin-cash.c5608b1a.svg";